import React from "react";
import { View } from "react-native";
import { useNavigation } from "@react-navigation/core";
import BankAccountList from "../../components/BankAccountList";
import { styles } from "./styles";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const WithdrawGPXAccountSelection = () => {
  const navigation = useNavigation();

  function onSelect(bankAccount) {
    navigation.navigate({
      name: "WithdrawGPX",
      params: { bankAccountId: bankAccount.id },
    });
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderTabs
        title={<FormattedMessage id="withdrawgpxaccountselection.titleReal" />}
        subtitle={
          <FormattedMessage id="withdrawgpxaccountselection.contaBancaria" />
        }
      />
      <View style={{ gap: 100 }}>
        <BankAccountList onSelect={onSelect} />

        <GoBackButton />
      </View>
    </View>
  );
};

export default WithdrawGPXAccountSelection;
